export default __webpack_public_path__ + "static/media/serve3.150a9d9a.png";